import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHighBeams = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24.07 18.052",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.07 0v2.02l-8.04-.07V0ZM24.07 4v2.02h-8.04V4.07ZM24.07 12.03v2.02l-8.04-.07v-1.95ZM24.07 16.03v2.02h-8.04V16.1ZM16.03 8.04h8.03v1.97h-8.03zM12.22.02c.9-.04 1.74-.1 1.84 1.04v15.93c-.09 1.09-.88 1.09-1.76 1.05-4.68-.18-11.28-2.41-12.18-7.7C-1.05 3.44 6.57.25 12.22.01Z" })
});
export default SvgHighBeams;
